import logger from "../../../util/logger";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { sizes, icons, positions, font } from "../../../enums";
import Button from "../../core/button";
import Reveal from "../../core/reveal";
import Segment from "../../core/segment"; //TODO update icon to icons.MINUS when available

var PanelExpandableContent = createComponent({
  displayName: 'PanelExpandableContent',
  propTypes: {
    expandedTrigger: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    collapsedTrigger: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    expansionPosition: PropTypes.oneOf([positions.TOP, positions.BOTTOM]),
    isExpanded: PropTypes.bool,
    children: PropTypes.node.isRequired,
    shouldTransitionOnMount: PropTypes.bool
  },
  defaultProps: {
    expandedTrigger: 'Advanced Options',
    collapsedTrigger: 'Advanced Options',
    expansionPosition: positions.TOP,
    isExpanded: false,
    shouldTransitionOnMount: false,
    isDisabled: false
  },
  lifecycles: {
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.props.setIsExpanded(nextProps.isExpanded);
      }
    }
  },
  state: {
    _isExpanded: {
      value: function value(p) {
        return p.isExpanded;
      },
      updater: function updater(setIsExpanded, p) {
        return {
          toggle: function toggle() {
            if (!p.isDisabled) setIsExpanded(!p._isExpanded);
          },
          setIsExpanded: setIsExpanded
        };
      }
    }
  },
  render: function render(props) {
    logger.deprecation("Prop \"expandedHeight\" has been deprecated and it will not change the height of the component.", !!props.expandedHeight);
    return /*#__PURE__*/React.createElement(Segment, null, props.expansionPosition === positions.TOP ? /*#__PURE__*/React.createElement(Reveal, {
      isActive: props._isExpanded
    }, /*#__PURE__*/React.createElement(Reveal.Content, {
      isActive: props._isExpanded,
      shouldCalcHeight: true,
      whenIsActive: true
    }, props.children)) : null, props._isExpanded ? typeof props.expandedTrigger !== 'string' ? /*#__PURE__*/React.createElement("span", {
      onClick: props.toggle
    }, props.expandedTrigger) : /*#__PURE__*/React.createElement(Button.Secondary, {
      isDisabled: props.isDisabled,
      size: sizes.MEDIUM,
      text: props.expandedTrigger,
      icon: {
        content: icons.MINUS,
        position: positions.LEFT
      },
      onClick: props.toggle,
      font: {
        emphasis: font.emphasis.NORMAL
      },
      isCompact: true
    }) : !props._isExpanded ? typeof props.collapsedTrigger !== 'string' ? /*#__PURE__*/React.createElement("span", {
      onClick: props.toggle
    }, props.collapsedTrigger) : /*#__PURE__*/React.createElement(Button.Secondary, {
      isDisabled: props.isDisabled,
      size: sizes.MEDIUM,
      text: props.collapsedTrigger,
      icon: {
        content: icons.PLUS,
        position: positions.LEFT
      },
      onClick: props.toggle,
      font: {
        emphasis: font.emphasis.NORMAL
      },
      isCompact: true
    }) : null, props.expansionPosition === positions.BOTTOM ? /*#__PURE__*/React.createElement(Reveal, {
      isActive: props._isExpanded
    }, /*#__PURE__*/React.createElement(Reveal.Content, {
      isActive: props._isExpanded,
      shouldCalcHeight: true,
      whenIsActive: true,
      shouldTransitionOnMount: props.shouldTransitionOnMount
    }, props.children)) : null);
  }
});
export default PanelExpandableContent;
//# sourceMappingURL=panel-expandable-content.js.map